import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link, Redirect } from "react-router-dom";
import history from "../history";
import { LastLocationProvider } from 'react-router-last-location';
import { useSelector } from 'react-redux';
import { authSelector } from './Auth/authSlice';
import Home from './Home/index';
import Login from './Auth/index';

import Dashboard from './Dashboard/index';
import ResetPassword from "./ResetPassword/index";
import ForgotPassword from "./ForgotPassword/index";
import PrivateRoute from './routes/PrivateRoute';
import AdminRoutes from './routes/admin/AdminRoutes';
import ClerkRoutes from './routes/clerk/ClerkRoutes';
import DDADRoutes from './routes/ddad/DDADRoutes';
import CHDRoutes from './routes/chd/CHDRoutes';
import Can from '../config/Can';

function Routers() {

  const { isLoggedIn, isGoogleSignIn, user } = useSelector(
    authSelector
  );


  return (
    <Router history={history}>
      <LastLocationProvider>
        <Switch>

          {/* <Route exact path='/' component={Home} />

            {!isGoogleSignIn &&
               <Redirect to="/" />
            } */}



          <Route exact path='/' component={Login} />
          <Route path="/login" component={Login} />
          <Route path="/reset-password" component={ResetPassword} />
          <Route path="/forgot-password" component={ForgotPassword} />
          {/* <PrivateRoute path="/dashboard" component={Dashboard} /> */}

          {user && (user.userType == 'admin' || user.userType == 'subAdmin') &&
            <AdminRoutes />
          }

          {user && user.userType == 'Clerk' &&
            <ClerkRoutes />
          }

          {user && user.userType == "DD's & AD's" &&
            <DDADRoutes />
          }

          {user && user.userType == "CHD" &&
            <CHDRoutes />
          }



          {/* <PrivateRoute
                    path="/dashboard"
                    render={props => (
                      <Can I="view" a="Profile">
                        {() => <Dashboard {...props} />}
                      </Can>
                    )}
                  /> */}

        </Switch>
      </LastLocationProvider>
    </Router>
  );
}

export default Routers;